module.exports = __webpack_public_path__ + "static/media/error-modal-tile.6959a6b0.svg";